<template>
  <v-layout row wrap>
    <v-flex d-flex md12 ml-3>
      <v-layout row wrap>
        <v-flex d-flex>
          <v-layout row>
            <v-flex md5 d-flex>
              <v-card class="background_general_suau" title flat>
                <v-card-title>
                  <v-icon size="45" :color="getColor[w_type]">developer_board</v-icon>
                  <span class="title tw-txt-color-primary pl-3">
                    <b>{{ `workers.title_${w_type}` | t }}</b>
                  </span>
                  <span class="pl-5 title tw-txt-color-primary">{{ worker_detail.description }}</span>
                </v-card-title>
              </v-card>
            </v-flex>
            <v-flex md4 d-flex class="hidden-sm-and-down">
              <v-card class="background_general_suau" title flat>
                <v-card-title>
                  <v-btn small fab color="primary" v-clipboard:copy="worker_detail.worker_detail_id">
                    <v-icon color="white">content_copy</v-icon>
                  </v-btn>
                  <span class="pl-3 tw-txt-color-primary hidden-sm-and-down">
                    <b>{{ 'workers.worker_id' | t }}</b>
                    <br />
                    {{ worker_detail.id }}
                  </span>
                </v-card-title>
              </v-card>
            </v-flex>
            <v-flex md2 d-flex>
              <v-card class="background_general_suau" title flat>
                <v-card-title>
                  <v-btn small fab color="primary" @click="openApi()" class="hidden-sm-and-down">
                    <v-icon color="white">storage</v-icon>
                  </v-btn>
                  <span class="tw-txt-color-primary pl-3">
                    <b>{{ 'workers.captures' | t }}</b>
                    <br /><br />
                  </span>
                </v-card-title>
              </v-card>
            </v-flex>
            <v-flex md1 d-flex>
              <v-card class="background_general_suau hidden-sm-and-down" title flat>
                <v-card-title>
                  <v-dialog v-model="status_delete" persistent max-width="600">
                    <template v-slot:activator="{ on }">
                      <v-btn small fab color="primary">
                        <v-icon color="white" @click="status_delete = true">delete</v-icon>
                      </v-btn>
                    </template>
                    <v-card>
                      <v-card-title>
                        <span class="headline">{{ 'workers_delete.title' | t }}</span>
                      </v-card-title>
                      <v-card-text>
                        <v-container grid-list-md>
                          <v-form v-model="formvalid" ref="form">
                            <v-layout wrap>
                              <v-icon color="red" @click="status_delete = true">warning</v-icon>
                              <b>{{ 'workers_delete.alert' | t }}</b>
                              <br />
                              {{ 'workers_delete.text' | t }}
                              <br />
                              {{ 'workers_delete.text_2' | t }}
                            </v-layout>
                          </v-form>
                        </v-container>
                      </v-card-text>
                      <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="blue darken-1" flat @click="status_delete = false">{{ 'workers_delete.close' | t }}</v-btn>
                        <v-btn color="blue darken-1" flat @click="confirmreg()">{{ 'workers_delete.save' | t }}</v-btn>
                      </v-card-actions>
                    </v-card>
                  </v-dialog>
                </v-card-title>
              </v-card>
            </v-flex>
          </v-layout>
        </v-flex>
        <v-flex md12>
          <v-flex md12>
            <v-card title flat>
              <!--
              <v-chip label color="#f1555012">
                <v-icon left color="#f15550">label</v-icon>
                <span class="subtitle hidden-sm-and-down">Words</span>
              </v-chip>
              -->
              <v-chip label outline class="background" v-for="word in worker_detail.words" :key="word + worker_detail">{{ word }}</v-chip>
            </v-card>
          </v-flex>
          <br />
        </v-flex>
      </v-layout>
    </v-flex>
  </v-layout>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  props: ['worker_detail', 'w_type', 'token'],
  computed: {
    ...mapGetters(['getColor', 'getColorLow'])
  },
  data() {
    return {
      status_delete: false,
      formvalid: true
    }
  },
  methods: {
    openApi() {
      window.open(`${window.location.protocol}//${this.w_type}.trawlingweb.com/posts/${this.worker_detail.id}?token=${this.token}`, '_blank')
    },
    confirmreg() {
      if (this.worker_detail.id !== '') {
        this.$http.get(`${window.location.protocol}//${this.w_type}.trawlingweb.com/delete/${this.worker_detail.id}?token=${this.token}`).then(data => {
          if (data.data.response && data.data.response.msg && data.data.response.msg === 'deleted') {
            this.status_delete = false
            this.$emit('updateworkers')
          }
        })
      }
    }
  }
}
</script>
<style scoped>
.background_general_suau {
  /*background-color: rgb(241 85 80 / 5%) !important;*/
  background-color: #f2f2f2 !important;
}

.primary--text {
  color: #303030 !important;
}

.background {
  background-color: rgb(241 85 80 / 15%) !important;
}

.tw-txt-color-primary {
  /*color: #00ff37 !important;*/
  color: #515151 !important;
}
</style>
